import { render, staticRenderFns } from "./IDVerifying.vue?vue&type=template&id=55a0e6d2"
import script from "./IDVerifying.vue?vue&type=script&lang=js"
export * from "./IDVerifying.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports